import { Intake } from "../models/Intake";
import api from "./api";
import { IntakeMessage } from "../models/IntakeMessage";
import { Participant } from "../models/Participant";

const BASE_PATH = "/api/v1/intakes";

export const IntakeService = {
  async getIntake(intakeId: string): Promise<Intake | null> {
    const res = await api.get(`${BASE_PATH}/${intakeId}`);
    return res.data.data as Intake;
  },

  async getMessages(intakeId: string): Promise<IntakeMessage[] | null> {
    const res = await api.get(`${BASE_PATH}/${intakeId}/messages`);
    return res.data.data as IntakeMessage[];
  },

  async getParticipants(intakeId: string): Promise<Participant[] | null> {
    const res = await api.get(`${BASE_PATH}/${intakeId}/participants`);
    return res.data.data as Participant[];
  },

  async getIntakes(): Promise<Intake[]> {
    const res = await api.get(`${BASE_PATH}`);
    return res.data.data ?? [];
  },

  async createIntake(
    intakeData: Omit<Intake, "_id" | "createdAt" | "updatedAt" | "matter">,
  ): Promise<string> {
    const res = await api.post(`${BASE_PATH}`, intakeData);
    return res.data?.data?._id;
  },

  async updateIntake(
    intakeId: string,
    updatedData: Partial<Intake>,
  ): Promise<void> {
    await api.patch(`${BASE_PATH}/${intakeId}`, updatedData);
  },

  async deleteIntake(intakeId: string): Promise<void> {
    await api.delete(`${BASE_PATH}/${intakeId}`);
  },
};
